import React from 'react';
import styles from '../../styles/PortalEstudiantesStyles/PortalEstudiantes.module.css';
import CookieConsent from './CookieConsent';

/**
 * Footer del Portal de Estudiantes
 * Incluye información de contacto, mapa de ubicación y aviso de cookies
 */
function FooterPortal() {
  // Coordenadas de la ubicación: Venustiano Carranza Sur 614, Centro, Monterrey, N.L.
  // Las coordenadas se incluyen en el query para el mapa embebido
  const mapQuery = encodeURIComponent('Venustiano Carranza Sur 614, Centro, 64000 Monterrey, N.L., México');
  
  return (
    <>
      {/* Footer principal */}
      <footer className={styles.footerPortal}>
        <div className={styles.footerContent}>
          {/* Sección de información de contacto */}
          <div className={styles.footerSection}>
            <h3 className={styles.footerTitle}>¿Tienes dudas?</h3>
            <p className={styles.footerSubtitle}>¡Estamos listos para resolverlas!</p>
            
            <div className={styles.footerContactItem}>
              <span className={styles.footerContactIcon}>📞</span>
              <a href="tel:+528188640099" className={styles.footerContactLink}>
                81 8864 0099
              </a>
            </div>
            
            <div className={styles.footerContactItem}>
              <span className={styles.footerContactIcon}>✉️</span>
              <a href="mailto:soporte@universidadlux.edu.mx" className={styles.footerContactLink}>
                soporte@universidadlux.edu.mx
              </a>
            </div>
            
            {/* Redes sociales */}
            <div className={styles.footerSocial}>
              <a 
                href="https://www.facebook.com/universidadlux" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.footerSocialLink}
                aria-label="Facebook"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.77,7.46H14.5v-1.9c0-.9.6-1.1,1-1.1h3V.5h-4.33C10.24.5,9.5,3.44,9.5,5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4Z"/>
                </svg>
              </a>
              <a 
                href="https://twitter.com/universidadlux" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.footerSocialLink}
                aria-label="Twitter"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.44,4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96,1.32-2.02-.88.52-1.86.9-2.9,1.1-.82-.88-2-1.43-3.3-1.43-2.5,0-4.55,2.04-4.55,4.54,0,.36.03.7.1,1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6,1.45-.6,2.3,0,1.56.8,2.95,2,3.77-.74-.03-1.44-.23-2.05-.57v.06c0,2.2,1.56,4.03,3.64,4.44-.67.2-1.37.2-2.06.08.58,1.8,2.26,3.12,4.25,3.16C5.78,18.1,3.37,18.74,1,18.46c2,1.3,4.4,2.04,6.97,2.04,8.35,0,12.92-6.92,12.92-12.93,0-.2,0-.4-.02-.6.9-.63,1.96-1.22,2.56-2.14Z"/>
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/universidadlux" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.footerSocialLink}
                aria-label="Instagram"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,2.16c3.2,0,3.58.01,4.85.07,1.17.05,1.8.25,2.23.41.56.22.96.48,1.38.9.42.42.68.82.9,1.38.16.43.36,1.06.41,2.23.06,1.27.07,1.65.07,4.85s-.01,3.58-.07,4.85c-.05,1.17-.25,1.8-.41,2.23-.22.56-.48.96-.9,1.38-.42.42-.82.68-1.38.9-.43.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.43-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68,1.38-.9.43-.16,1.06-.36,2.23-.41,1.27-.06,1.65-.07,4.85-.07M12,0C8.74,0,8.33.01,7.05.07,5.78.13,4.9.33,4.14.63c-.78.3-1.44.71-2.1,1.37-.66.66-1.07,1.32-1.37,2.1C.37,4.9.17,5.78.11,7.05.05,8.33,0,8.74,0,12s.01,3.67.07,4.95c.06,1.27.26,2.15.56,2.91.3.78.71,1.44,1.37,2.1.66.66,1.32,1.07,2.1,1.37.76.3,1.64.5,2.91.56,1.28.06,1.69.07,4.95.07s3.67-.01,4.95-.07c1.27-.06,2.15-.26,2.91-.56.78-.3,1.44-.71,2.1-1.37.66-.66,1.07-1.32,1.37-2.1.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91-.3-.78-.71-1.44-1.37-2.1-.66-.66-1.32-1.07-2.1-1.37-.76-.3-1.64-.5-2.91-.56C15.67.05,15.26,0,12,0Z"/>
                  <circle cx="12" cy="12" r="3.6"/>
                  <circle cx="18.41" cy="5.59" r="1.44"/>
                </svg>
              </a>
              <a 
                href="https://www.youtube.com/universidadlux" 
                target="_blank" 
                rel="noopener noreferrer"
                className={styles.footerSocialLink}
                aria-label="YouTube"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.5,6.19a3.02,3.02,0,0,0-2.12-2.14C19.5,3.5,12,3.5,12,3.5s-7.5,0-9.38.55A3.02,3.02,0,0,0,.5,6.19,31.56,31.56,0,0,0,0,12a31.56,31.56,0,0,0,.5,5.81,3.02,3.02,0,0,0,2.12,2.14c1.88.55,9.38.55,9.38.55s7.5,0,9.38-.55a3.02,3.02,0,0,0,2.12-2.14A31.56,31.56,0,0,0,24,12,31.56,31.56,0,0,0,23.5,6.19ZM9.54,15.57V8.43L15.82,12Z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Sección de ubicación y mapa */}
          <div className={styles.footerSection}>
            <h3 className={styles.footerTitle}>¡Visítanos!</h3>
            
            <div className={styles.footerAddressContainer}>
              <div className={styles.footerContactItem}>
                <span className={styles.footerContactIcon}>📍</span>
                <address className={styles.footerAddress}>
                  Venustiano Carranza Sur 614,<br />
                  Centro, 64000 Monterrey, N.L.
                </address>
              </div>
            </div>

            {/* Mapa de Google Maps */}
            <div className={styles.footerMapContainer}>
              <iframe
                title="Ubicación Universidad Lux"
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${mapQuery}&zoom=16`}
                width="100%"
                height="200"
                style={{ border: 0, borderRadius: '8px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>

        {/* Línea de privacidad */}
        <div className={styles.footerPrivacy}>
          <a 
            href="https://www.universidadlux.edu.mx/aviso-de-privacidad" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.footerPrivacyLink}
          >
            Aviso de privacidad
          </a>
        </div>

        {/* Copyright */}
        <div className={styles.footerCopyright}>
          <p>© {new Date().getFullYear()} Universidad Lux. Todos los derechos reservados.</p>
          <div className={styles.footerLanguage}>
            <span className={styles.footerLanguageIcon}>🌐</span>
            <span>ES Español | México</span>
          </div>
        </div>
      </footer>

      {/* Componente de aviso de cookies */}
      <CookieConsent />
    </>
  );
}

export default FooterPortal;
